export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#003F2A',
    light: '#F6F6F6',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#FFFFFF33',
    contrastText: '#22211F',
  },
  text: {
    brand: '#003F2A',
    primary: '#001A11',
    secondary: '#3E444E',
    tertiary: '#626D7C',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#001A11',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#002519',
    tableSubhead: '#EDE7DE',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDE7DE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#BBE6FE',
    offer: '#EDE7DE',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#B6BFA5',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
